import React, { Component } from 'react'
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './CustomNavbar.css'

export default class CustomNavbar extends Component {
  render() {
    return (
      <Navbar default collapseOnSelect>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/">React.waleedrehman.co.uk</Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav pullRight>
            <NavItem eventKey={1} componentClass={Link} href="/" to="/">
              Home
            </NavItem>
            <NavItem eventKey={2} componentClass={Link} href="/permutation" to="/permutation">
              Permutation
            </NavItem>
            <NavItem eventKey={3} componentClass={Link} href="/greeting" to="/greeting">
              Greeting
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomNavbar.jsx